import React from 'react';
import { hasSomeActivityBooked } from 'Components/utils/booking/bookingUtils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { FlyerCard } from 'Components/frameworks/flyer-card/FlyerCard';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  category: ActivitiesCategoryEntity;
  hasCounters?: boolean;
  hasOnlineBookableCount?: boolean;
  hasOnlineBookableTotal?: boolean;
  isSmall?: boolean;
  onClick?: () => void;
  url?: string;
};
export const ActivitiesCategoryCard = ({
  className,
  category,
  hasCounters = false,
  hasOnlineBookableCount = false,
  hasOnlineBookableTotal = false,
  isSmall = false,
  onClick,
  url,
  ...rest
}: Props) => {
  const onlineBookableActivitiesCount = category?.onlineBookableCount || 0;
  const totalActivities = hasOnlineBookableTotal
    ? onlineBookableActivitiesCount
    : (category?.activitiesCounters?.included || 0) + (category?.activitiesCounters?.onDemand || 0);
  return (
    <FlyerCard
      {...rest}
      className={className}
      data-testid={category.name}
      imageUrl={category.images?.[0]}
      isChecked={hasSomeActivityBooked(category)}
      isSmall={isSmall}
      label={t('common.activities.label')}
      onClick={onClick}
      title={category?.name || t('booking.activities.otherActivities')}
      url={url}
    >
      {hasCounters && (
        <div className="mt-15 basis-[20%]">
          {!!totalActivities && (
            <p className="flex items-center gap-10 text-14 font-bold text-black">
              {t(
                totalActivities > 1
                  ? 'common.activities.counters._n'
                  : 'common.activities.counters._1',
                {
                  count: totalActivities,
                },
              )}{' '}
              <Icon hasRtl name={ICONS.ARROW_RIGHT} width="0.75em" />
            </p>
          )}
          {hasOnlineBookableCount && onlineBookableActivitiesCount > 0 && (
            <p className="flex items-center justify-between text-14 font-bold text-sienna">
              {t('booking.activities.onDemandCount.totalOnline', {
                count: onlineBookableActivitiesCount,
              })}
            </p>
          )}
        </div>
      )}
    </FlyerCard>
  );
};
